import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useOnboardingStore = defineStore({
  id: 'onboardingStore',
  state: () => ({
    statusButtonsLoading: false,
    error: null,
    clientsLocal: [],
    clientClickupTask: '',
  }),
  getters: {},
  actions: {
    setClientClickupTask(task) {
      this.clientClickupTask = task
    },

    async getClients(params = {}) {
      const {data} = await axios.get('onboarding-clients', {params: params})

      this.clientsLocal = data
      return data
    },
    async getOnboardingClient(hash) {
      const {data} = await axios.get(`onboarding-clients/${hash}`, {
        params: {
          with: [
            'sale_manager',
            'media_planner',
            'media_planner_2',
            'csm',
            'csm_2',
            'questionnaire',
            'annex',
            'commission',
            'meta',
            'documents',
            'retainer_requests',
            'retainers',
          ],
          with_count: [
            'users',
            'quick_books_customers',
            'documents',
            'estimate_invoices',
            'payments',
            'confirmed_payments',
            'retainers',
            'statuses_history',
          ],
        },
      })

      return data
    },
    async getDocument(hash) {
      const {data} = await axios.get('onboarding-document/' + hash)

      return data
    },
    async createOnboardingClient(payload) {
      const {data} = await axios.post('onboarding-clients', payload)

      return data
    },
    async updateOnboardingClient(hash, payload) {
      const {data} = await axios.patch(`onboarding-clients/${hash}`, payload)

      return data
    },
    async sendQuestioner(hash) {
      const {data} = await axios.post(`onboarding-clients/${hash}/send-questioner`)

      return data
    },
    async saveAnnex(hash, payload) {
      const {data} = await axios.post(`onboarding-clients/${hash}/save-annex`, payload)

      return data
    },
    async sendAnnex(hash, payload = {}) {
      const {data} = await axios.post(`onboarding-clients/${hash}/send-annex`, payload)

      return data
    },
    async saveRetainerSignAnnex(hash, payload) {
      const {data} = await axios.post(`onboarding-clients/${hash}/save-retainer-sign-annex`, payload)

      return data
    },
    async saveAndSendRetainerSignAnnex(hash, payload) {
      const {data} = await axios.post(`onboarding-clients/${hash}/save-and-send-retainer-sign-annex`, payload)

      return data
    },
    async markRetainerSigned(hash) {
      const {data} = await axios.post(`retainer-sign/${hash}/mark-signed`)

      return data
    },
    async forceRetainerSignStatus(hash, status) {
      const {data} = await axios.post(`retainer-sign/${hash}/force-status`, {status})

      return data
    },
    async changeOnboardingClientStatus(hash, status, status_message) {
      const {data} = await axios.post(`onboarding-clients/${hash}/change-status`, {status, status_message})

      return data
    },
    async forceChangeOnboardingClientStatus(hash, status, status_message) {
      const {data} = await axios.post(`onboarding-clients/${hash}/force-change-status`, {status, status_message})

      return data
    },
    async changeStatusToClientTransfer(hash, payload, params = {}) {
      const {data} = await axios.post(`onboarding-clients/${hash}/change-status`, payload, {params})

      return data
    },

    toggleStatusButtonsLoading (value){
      this.statusButtonsLoading = value
    }
  },
})
